<template>
    <div>
        <slide-up-down v-model="activeSlide" :duration="1000">
            <div class="block w-full mt-14"></div>
            <div v-if="data.image.url" class="w-full relative overflow-hidden mb-8" style="--aspect-ratio: 1.45;">
                <img class="absolute w-full h-full object-cover" :src="data.image.url" :alt="data.image.alt">
            </div>

            <h3 class="heading--medium mb-7">{{data.name}}</h3>
            <p v-if="data.history" class="text-20 mb-5">History: <br> {{data.history}}</p>
            <p v-if="data.mission" class="text-20 mb-5">Mission: <br> {{data.mission}}</p>
            <p class="text-20">Founders: <br>
                <span class="mr-5" v-for="founder in data.founders" :key="founder.name" v-html="founder.name"></span> 
            </p>

            <a :href="data.link.url" class="link link--white mt-8 inline-block" v-html="data.link.title" v-if="data.link"  :target="[data.link.target === '_blank' ? data.link.target : '_self']"></a>
        </slide-up-down>
    </div>
</template>

<script>
import SlideUpDown from 'vue3-slide-up-down'

export default {
    name: "SlideToggle",
    props: ['data', 'open'],
    data() {
        return {
            activeSlide: this.open,
        }
    },
    watch: {
        open: function(newVal, oldVal) { // watch it
            this.activeSlide = newVal;
        }
    },
    components: {SlideUpDown},
}
</script>

<style scoped>

</style>